import React from "react";
import { useLang } from "@/context/LanguageContext";

const TRUST_IMG =
  "https://images.unsplash.com/photo-1764605206511-7a649d9df63b?crop=entropy&cs=srgb&fm=jpg&w=1400&q=72";

const About = () => {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-32 bg-[color:var(--bg-primary)] border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <p className="label-eyebrow">Faustitur</p>
          <h2
            data-testid="about-title"
            className="font-display text-3xl sm:text-4xl lg:text-5xl mt-4 text-white tracking-tight"
          >
            {t.trust.title}
          </h2>
          <p className="mt-6 text-zinc-300 leading-relaxed text-base sm:text-lg">
            {t.trust.body}
          </p>

          <div className="mt-10 grid grid-cols-3 gap-4">
            {t.trust.stats.map((s, i) => (
              <div
                key={i}
                data-testid={`trust-stat-${i}`}
                className="border-l-2 border-[color:var(--gold)] pl-4"
              >
                <p className="font-display text-3xl sm:text-4xl gold-text leading-none">
                  {s.value}
                </p>
                <p className="mt-2 text-[10px] tracking-[0.25em] uppercase text-zinc-400">
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2 relative">
          <div className="relative overflow-hidden border border-white/10">
            <img
              src={TRUST_IMG}
              alt="Faustitur fleet"
              className="w-full h-[420px] object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-black/60 via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-4 -left-4 hidden sm:block w-24 h-24 border border-[color:var(--gold)]/40" />
        </div>
      </div>
    </section>
  );
};

export default About;
